import { useTranslation } from "react-i18next";
import React from "react";
import { CardSpg } from "@duosoftbg/nacid-components";
import { CardContent } from "@mui/material";
import PageWrapper from "../../../components/common/layout/PageWrapper";
import AdminConsoleView from "../../../components/admin/console/view/AdminConsoleView";

const AdminConsole = () => {
  const { t } = useTranslation();
  const title = `${t("t.page.admin.console")}`;

  return (
    <PageWrapper title={title}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          <AdminConsoleView />
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};

export default AdminConsole;
